import React from 'react';

class WebGLErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Catch ALL errors inside the 3D canvas to prevent white screens
        console.error("3D Error Caught:", error.message);
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("3D Canvas Error:", error, errorInfo);
        this.setState({ hasError: true });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="absolute inset-0 z-0 bg-[#020205] flex items-center justify-center">
                    {/* Fallback Static Background */}
                    <div className="absolute inset-0 bg-gradient-to-b from-[#020205] via-[#111133] to-[#020205] opacity-50" />
                    <div className="relative z-10 text-white/20 font-mono text-xs">
                        3D Disabled (Low Resources)
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default WebGLErrorBoundary;
